export default __webpack_public_path__ + "static/media/camping.b554ad1b.svg";